<template>
  <el-dialog v-dialogDrag :title="$t('用户服务协议')" :append-to-body="true"  :visible="showModal" width="70%" top @close="close">
    <div style="height: 500px;overflow: auto;">
      <div v-html="html"></div>
    </div>
    <span slot="footer" class="dialog-footer" style="text-align: center;">
			    <el-button size="small" type="primary" @click="check">{{$t('我已阅读并同意')}}</el-button>
				</span>
  </el-dialog>
</template>
<script>

import {getLanguage} from '@/utils/auth'
export default {
  props:{
    showModal:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      html:''
    }
  },
  mounted(){
    let htmlUrl = ''
    let language = getLanguage()
    if(language=='zh-TW'){
      htmlUrl = location.origin+"/userAgreement_TW.html"
    }else{
      htmlUrl = location.origin+"/userAgreement.html"
    }
    this.loadHtml(htmlUrl)
  },
  methods: {
    close(){
      this.$emit('update:showModal', false)
    },
    loadHtml(url) {
      if (url && url.length > 0) {
        // 加载中
        this.loading = true
        let param = {
          accept: 'text/html, text/plain'
        }
        this.$http.get(url, param).then((data) => {
          this.loading = false
          // 处理HTML显示
          this.html = data
        }).catch(() => {
          this.loading = false
          this.html = this.$t('加载失败')
        })
      }
    },
    check() {
      this.$emit('check')
      this.close()
    }
  }
}
</script>